/**
 * Orbe de "la IA está hablando" — wrapper del VoicePoweredOrb para los tres
 * puntos de voz (EPIC conversacional, D-Talk, Mapa de Talento).
 * `floating` lo muestra como overlay abajo a la derecha solo mientras habla.
 */
import { VoicePoweredOrb } from '@/components/ui/voice-powered-orb';
import { cn } from '@/lib/utils';

export function AiSpeakingOrb({
  speaking,
  listening = false,
  size = 140,
  floating = false,
  className,
}: {
  speaking: boolean;
  listening?: boolean;
  size?: number;
  floating?: boolean;
  className?: string;
}) {
  if (floating && !speaking) return null;
  return (
    <div
      className={cn(
        floating &&
          'pointer-events-none fixed bottom-24 right-6 z-40 drop-shadow-[0_0_24px_rgba(96,165,250,0.35)]',
        className
      )}
      style={{ width: size, height: size }}
    >
      <VoicePoweredOrb active={speaking || listening} hue={listening && !speaking ? 40 : 0} />
    </div>
  );
}
